import { denormalize } from 'normalizr'
import entitySchema from 'redux-modules/entitySchema'

function denormalizeEntity(entityType, entity, entities){
  return denormalize(entity, entitySchema[entityType], entities)
}

export default denormalizeEntity
